import toString from './toString.js';
import upperFirst from './upperFirst.js';

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

export default capitalize;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/capitalize.js
// module id = 221
// module chunks = 0